export enum AgentStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  CONFIRM = 'CONFIRM',
  VERIFIED = 'VERIFIED',
  IDENTIFIED = 'IDENTIFIED',
  CONTACT_DRAFT = 'CONTACT_DRAFT',
  CONTRACT_DRAFT = 'CONTRACT_DRAFT',
  FAILED_SCORING = 'FAILED_SCORING',
  FAILED_SCREENING = 'FAILED_SCREENING',
  PENDING_SECURITY = 'PENDING_SECURITY',
  CONFIRM_SECURITY = 'CONFIRM_SECURITY',
  DENIED = 'DENIED',
  APPROVED = 'APPROVED',
  CONTRACT_DRAFT_FULL = 'CONTRACT_DRAFT_FULL',
}
